<template>
    <div class="log-details">
        <ul>
            <li v-for="log in logList" v-bind:key="log">
                <h4>{{ log.name }}</h4>
                <div>
                    <table class='table'>
                        <thead class='table__header'>
                            <tr>
                                <th>Product</th>
                                <th>Detail</th>
                            </tr>
                        </thead>
                        <tbody class="table__row">
                            <tr v-for="error in log.list_error" v-bind:key="error">
                                <td>{{ error.product }}</td>
                                <td>{{ error.error_msg }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
  props: {
    logList: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
</style>
